import {applySpec, makeGet} from '@yandex-delivery/utils'

import type {CompanyInfoForm, StateResponse} from '../../../repo/cargo-crm/types'

type PartialCompanyInfoForm = Pick<CompanyInfoForm, 'name' | 'email' | 'phone'>

const stateGet = makeGet<StateResponse>()

export const getDisableReason = stateGet('new_ticket.disable_reason')
export const getUnresolvedTicketID = stateGet('new_ticket.disable_reason.details.ticket_id')
export const getNewTicketToken = stateGet('new_ticket.token')
export const getPartialCompanyInfo: (r: StateResponse) => PartialCompanyInfoForm = applySpec({
  email: stateGet('passport_account.emails[0].address'),
  phone: stateGet('passport_account.phones[0].phone'),
})
